import { TAdminObjectAnalog } from '@root-gipro/modules/AdminPanel/interfaces/adminObjectsAnalog'
import { AdminObjectsAnalogSortNames } from '@root-gipro/modules/AdminPanel/constants/constants'

export const getObjectsAnalogSelector = (
	objectsAnalog: TAdminObjectAnalog[]|null,
	sort: string,
	search?: string
): TAdminObjectAnalog[] => {
	
	let result: TAdminObjectAnalog[] = objectsAnalog ?? [];
	const sortParamsArr = sort.split(' ');
	const sortParams: [AdminObjectsAnalogSortNames, string|undefined] = [
		sortParamsArr[0] as AdminObjectsAnalogSortNames,
		sortParamsArr[1]
	];
	const newDirection = 1 in sortParams && sortParams[1] === 'DESC' ? 'ASC' : 'DESC';
	
	if(objectsAnalog?.length) {
		result = [...objectsAnalog].sort((a, b) => {
			if(sortParams[0] === AdminObjectsAnalogSortNames.NUMBER_ID) {

				if(newDirection === 'ASC') {
					return a.id - b.id; // Сортировка по возрастанию
				} else {
					return b.id - a.id; // Сортировка по убыванию
				}
			}

			if(
				sortParams[0] === AdminObjectsAnalogSortNames.NAME ||
				sortParams[0] === AdminObjectsAnalogSortNames.TH_NAME
			) {
				
				const nameA = a[sortParams[0]]?.toLowerCase();
				const nameB = b[sortParams[0]]?.toLowerCase();

				if(nameA && nameB) {
					
					if(newDirection === 'ASC') {
						return nameA.localeCompare(nameB); // Сортировка по возрастанию
					} else {
						return nameB.localeCompare(nameA); // Сортировка по убыванию
					}
					
				}
			}
			
			return 0;
		});

		if(search) {
			result = result.filter(obj => {

				const idMatch = search ? obj.id.toString().includes(search) : true;
				
				const nameMatch = search
					? obj.name.toLowerCase().includes(search.toLowerCase())
					: true;
				
				const nameTHMatch = search
					? obj.th_name?.toLowerCase().includes(search.toLowerCase())
					: true;
				
				if(idMatch) return true;
				if(nameMatch) return true;
				if(nameTHMatch) return true;
				
				return false;
			});
      
		}
  }

	return result;
};